import {SplitBooking} from '../../types/room'

export const getSplitBookingRooms = (splitBooking: SplitBooking) => {
  return splitBooking.offers.map(offer => offer.room)
}
